// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../imgs/fundoEsqAzul.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cardo:wght@700&family=Inter:wght@400;600&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MOVIMENTAÇÂO CARDS */

.alteraSenha{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-color:rgba(0, 0, 0, 0.0);
}


.alteraSenha .containerMudaSenha{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 70vh;
    aspect-ratio: 1.3/2;
    max-width: 95%;
    background-color: #fff;
    margin: auto;
    border-radius: 10px;
    color: #000
}

.alteraSenha .titleMudaSenha{
    font-size: 2em;
    margin: 30px 0 15px 0;
    font-family: 'FanwoodText-Regular';
}

.alteraSenha .containerMudaSenha input {
    background-color: var(--white-color);
    width: 70%;
    margin-bottom: 3%;
    color: #000;
    font-size: 1.2em;
    border-radius: 7px;
    padding: 8px;
    border: 1.5px solid #dededf;
}

.alteraSenha .containerMudaSenha input:is(:focus, :hover){
    border-color: var(--azulthink);
    background-color: #fff;
    box-shadow: 0 0 0 4px #00AA6B1a;
    outline: none;
}

.alteraSenha .buttonAlteraSenha,
.alteraSenha .buttonCancelMudarSenha{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40%;
    margin: 10px auto 10px auto;
    cursor: pointer;
    font-size: 1em;
    font-family: 'Cardo-Bold', 'sans-serif';
    border: 2px solid var(--black-color);
    color: #000;
    padding: 10px 20px;
    text-align: center;
    border-radius: 5px;
}


.alteraSenha .buttonAlteraSenha:hover{
    background-color: var(--escuro-azul-color);
    color: var(--black-color);
}


.alteraSenha .buttonCancelMudarSenha{
    border: 2px solid var(--escuro-vermelho-vinho-color);
    color: var(--black-color);
    background-color: var(--escuro-vermelho-vinho-color);
}

.alteraSenha .buttonCancelMudarSenha:hover{
    color: var(--black-color);
    background-color: var(--medio-alaranjado-color);
}

.alteraSenha .navbar {
    min-width: 100vw;
}
@media (max-width: 767px){

    .alteraSenha .buttonAlteraSenha,
    .alteraSenha .buttonCancelMudarSenha{
        width: 70%;
    }
  
  
  }`, "",{"version":3,"sources":["webpack://./src/assets/css/alteraSenha.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAGvB;IACI,yDAAiD;IACjD,sBAAsB;IACtB,mCAAmC;AACvC;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IAEtB,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,uCAAuC;IACvC,oCAAoC;IACpC,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,0CAA0C;IAC1C,yBAAyB;AAC7B;;;AAGA;IACI,oDAAoD;IACpD,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;AACpB;AACA;;IAEI;;QAEI,UAAU;IACd;;;EAGF","sourcesContent":["/* MOVIMENTAÇÂO CARDS */\r\n@import url('https://fonts.googleapis.com/css2?family=Cardo:wght@700&family=Inter:wght@400;600&display=swap');\r\n\r\n.alteraSenha{\r\n    background-image: url('../imgs/fundoEsqAzul.png');\r\n    background-size: cover;\r\n    background-color:rgba(0, 0, 0, 0.0);\r\n}\r\n\r\n\r\n.alteraSenha .containerMudaSenha{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 70vh;\r\n    aspect-ratio: 1.3/2;\r\n    max-width: 95%;\r\n    background-color: #fff;\r\n    margin: auto;\r\n    border-radius: 10px;\r\n    color: #000\r\n}\r\n\r\n.alteraSenha .titleMudaSenha{\r\n    font-size: 2em;\r\n    margin: 30px 0 15px 0;\r\n    font-family: 'FanwoodText-Regular';\r\n}\r\n\r\n.alteraSenha .containerMudaSenha input {\r\n    background-color: var(--white-color);\r\n    width: 70%;\r\n    margin-bottom: 3%;\r\n    color: #000;\r\n    font-size: 1.2em;\r\n    border-radius: 7px;\r\n    padding: 8px;\r\n    border: 1.5px solid #dededf;\r\n}\r\n\r\n.alteraSenha .containerMudaSenha input:is(:focus, :hover){\r\n    border-color: var(--azulthink);\r\n    background-color: #fff;\r\n    -webkit-box-shadow: 0 0 0 4px #00AA6B1a;\r\n    box-shadow: 0 0 0 4px #00AA6B1a;\r\n    outline: none;\r\n}\r\n\r\n.alteraSenha .buttonAlteraSenha,\r\n.alteraSenha .buttonCancelMudarSenha{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 40%;\r\n    margin: 10px auto 10px auto;\r\n    cursor: pointer;\r\n    font-size: 1em;\r\n    font-family: 'Cardo-Bold', 'sans-serif';\r\n    border: 2px solid var(--black-color);\r\n    color: #000;\r\n    padding: 10px 20px;\r\n    text-align: center;\r\n    border-radius: 5px;\r\n}\r\n\r\n\r\n.alteraSenha .buttonAlteraSenha:hover{\r\n    background-color: var(--escuro-azul-color);\r\n    color: var(--black-color);\r\n}\r\n\r\n\r\n.alteraSenha .buttonCancelMudarSenha{\r\n    border: 2px solid var(--escuro-vermelho-vinho-color);\r\n    color: var(--black-color);\r\n    background-color: var(--escuro-vermelho-vinho-color);\r\n}\r\n\r\n.alteraSenha .buttonCancelMudarSenha:hover{\r\n    color: var(--black-color);\r\n    background-color: var(--medio-alaranjado-color);\r\n}\r\n\r\n.alteraSenha .navbar {\r\n    min-width: 100vw;\r\n}\r\n@media (max-width: 767px){\r\n\r\n    .alteraSenha .buttonAlteraSenha,\r\n    .alteraSenha .buttonCancelMudarSenha{\r\n        width: 70%;\r\n    }\r\n  \r\n  \r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
